import { DrawerMenuItem } from 'Components/Layout/DrawerMenu/DrawerMenuItem'
import type { NavLinkItem } from 'Components/Layout/DrawerMenu/types'
import { isSuperuser } from 'Services/common/Features/User/userSlice'
import useTypedSelector from 'Store'
import { MenuList } from '@mui/material'

interface DrawerMenuItemListProps {
  navLinks: NavLinkItem[]
  rootUrl: string
  children?: React.ReactNode
}

function DrawerMenuItemList({ navLinks, rootUrl, children }: Readonly<DrawerMenuItemListProps>) {
  const { user } = useTypedSelector(state => state.user)

  return (
    <MenuList sx={{ height: '100%', px: 2 }}>
      {navLinks.map((item, i) => {
        // Superuser has access to every page
        if (isSuperuser(user)) {
          return <DrawerMenuItem key={`${item.title}-${i}`} navLinkItem={item} rootUrl={rootUrl} />
        }
        if (item.allowedGroups) {
          // Check if the logged-in user belongs to a group that has access to page
          if (item.allowedGroups.some(group => user?.groups.includes(group))) {
            return (
              <DrawerMenuItem key={`${item.title}-${i}`} navLinkItem={item} rootUrl={rootUrl} />
            )
          } else {
            // The user did not belong to a group that has access to page, so we hide the menu item
            return null
          }
        } else {
          // If no allowedGroups are defined for the menu item, it is displayed to everyone
          return <DrawerMenuItem key={`${item.title}-${i}`} navLinkItem={item} rootUrl={rootUrl} />
        }
      })}
      {children}
    </MenuList>
  )
}

export { DrawerMenuItemList }
